import { Theme, createStyles } from '@material-ui/core'

export const styles = (theme: Theme) =>
  createStyles({
    typography: {
      marginTop: theme.spacing(1)
    }
  })
